import type { CityWeather } from "./agendaWeatherTypes";

export function normalizeWeatherCityKey(label: string): string {
  return label
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{M}/gu, "");
}

type ResolveCityWeatherOptions = {
  preferredCity?: string | null;
  commercialRegionId?: number | null;
  allowSingleCityFallback?: boolean;
};

export function resolveCityWeatherForLabel(
  regionLabel: string,
  cities: CityWeather[],
  options: ResolveCityWeatherOptions = {}
): CityWeather | null {
  if (cities.length === 0) {
    return null;
  }

  const regionKey = normalizeWeatherCityKey(regionLabel);
  if (regionKey) {
    const byRegionName = cities.find(
      (entry) => normalizeWeatherCityKey(entry.cityName) === regionKey
    );
    if (byRegionName) {
      return byRegionName;
    }
  }

  if (options.commercialRegionId != null && regionKey) {
    const byRegionId = cities.find(
      (entry) => entry.commercialRegionId === options.commercialRegionId
    );
    if (
      byRegionId &&
      normalizeWeatherCityKey(byRegionId.cityName) === regionKey
    ) {
      return byRegionId;
    }
  }

  if (options.allowSingleCityFallback && cities.length === 1) {
    return cities[0];
  }

  return null;
}

export function indexCityWeatherEntries(
  cities: CityWeather[]
): Map<string, CityWeather> {
  const map = new Map<string, CityWeather>();

  cities.forEach((entry) => {
    const labels = new Set<string>();
    if (entry.cityName.trim()) {
      labels.add(entry.cityName.trim());
      labels.add(normalizeWeatherCityKey(entry.cityName));
    }

    labels.forEach((label) => {
      if (!map.has(label)) {
        map.set(label, entry);
      }
    });
  });

  return map;
}
